import { Modal } from '@mantine/core'
import ModalClasses from './styles.module.css'
import '../../styles/variables.css'

export default Modal.extend({
    defaultProps: {
        size: 'md',
        centered: true,
        radius: 'lg',
        withCloseButton: true,
        // The icon-only close button needs a name; a caller's closeButtonProps replaces this one.
        closeButtonProps: { 'aria-label': 'Close' },
    },
    classNames: ModalClasses,
})
